export default __webpack_public_path__ + "static/media/icon_mydata_accepting.8ec22210.svg";